// Copyright (c) 2017 Deere & Company

import Tab from '../../../../src/shared/state/tab';

export const getTab = resultsCount => [
    new Tab({
        count: resultsCount,
        label: 'PRODUCTS_WITH_COUNT',
        route: '/products/products-by-customer'
    })
];



// WEBPACK FOOTER //
// ./src/product/products-by-customer/services/tab.js